<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()" />
		</div>
		<form class="form" @submit.prevent="submit">
			<div class="tittle_verified">
				验证身份证
			</div>
			<div class="">
				为保障账户安全，请完成身份证验证
				{{ data.mobile }}
			</div>
			<div class="item">
				<div class="ari_font">
					姓名
				</div>
				<input v-model="datas.name" class="card" type="text" placeholder="请输入姓名">
			</div>
			<div class="item">
				<div class="ari_font">
					身份证号码
				</div>
				<input v-model="datas.idcard" class="card" type="text" placeholder="请输入身份证">
			</div>
			<!-- 上传身份证正面 -->
			<!-- <div v-if="!previewImageUrl" class="add-card" @click="handleFileUpload">上传身份证正面</div>
			<input type="file" ref="fileInput" style="display: none" accept="image/*"
				@change="(e) => handleFileChange(e, 1)" />
			<img v-if="previewImageUrl" :src="previewImageUrl" alt="身份证预览" class="preview-img" /> -->

			<!-- 上传身份证背面 -->
			<!-- <div v-if="!previewImageUrl2" class="add-card" @click="handleFileUploads">上传身份证背面</div>
			<input type="file" ref="fileInputs" style="display: none" accept="image/*"
				@change="(e) => handleFileChange(e, 2)" />
			<img v-if="previewImageUrl2" :src="previewImageUrl2" alt="身份证预览" class="preview-img" /> -->

			<div class="item" style="display: none;">
				<input v-model.trim="code" type="text" class="inp" :placeholder="$t('authEmail.code')">
				<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
					<template v-slot="timeData">
						<span @click="sendcode">{{
							timeData.seconds > 0
								? timeData.seconds
								: $t('authEmail.sendcode')
						}}</span>
					</template>
				</van-count-down>
			</div>
			<button type="submit" class="basic_btn sbtn" :class="code == '' ? 'no_touch' : ''">
				{{ $t('authEmail.submit') }}
			</button>
		</form>
	</div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox } from "vant";
import Fetch from '../../utils/fetch';
import Api from "../../interface/index";
import bsHeader from '../../components/bsHeader.vue';
import {
	Overlay, Uploader, Button, DropdownMenu, DropdownItem, Toast
} from 'vant';
import axios from 'axios'
Vue.use(CountDown)
	.use(Checkbox);
export default {
	name: "Setpwd",
	components: {
		bsHeader
	},
	data() {
		return {
			data: {},
			datas: {
				name: '',
				img: '',
				back_img:'',
				idcard: ''
			},
			time: 0,
			code: '',
			previewImageUrl: "",
			previewImageUrl2: ""
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
	},
	methods: {
		handleFileUploads() {
			this.$refs.fileInputs.click();
		},
		// 点击上传按钮，触发隐藏input的点击
		handleFileUpload() {
			this.$refs.fileInput.click();
		},

		// 文件选择后触发
		handleFileChange(event, num) {
			const file = event.target.files[0];

			if (!file) return;

			// 验证文件类型（图片）
			if (!file.type.startsWith('image/')) {
				alert('请上传图片格式的身份证照片');
				return;
			}

			// 验证文件大小（例如最大5MB）
			const maxSizeMB = 5;
			if (file.size / 1024 / 1024 > maxSizeMB) {
				alert(`文件大小不能超过${maxSizeMB}MB`);
				return;
			}
			this.uploadFile(file, num);
		},

		// 模拟上传函数
		uploadFile(file, num) {
			

			if (num == 1) {
				this.previewImageUrl = URL.createObjectURL(file);
			} else {
				this.previewImageUrl2 = URL.createObjectURL(file);
			}

			let formData = new FormData();
			formData.append('language', this.$i18n.locale || "zh_cn");
			formData.append('file', file);
			formData.append('id', this.$router.history.current.params.id);
			formData.append('token', localStorage.getItem('token'));
			Toast.loading({
				forbidClick: true,
				duration: 20000
			});
			axios.post(Api.commonUrl + "/api/index/realname_upload", formData).then((r) => {
				Toast.clear();
				if (r.data.code === 1) {
					if (num == 1) {
						this.datas.img = r.data.data;
					} else {
						this.datas.back_img = r.data.data;
					}
				} else {
					if (r.data.info) {
						this.$toast(r.data.info);
					} else {
						this.$toast(this.$t('account.uploadFail'));
					}
				}
			});
			// const reader = new FileReader();
			// reader.onload = (e) => {
			// 	console.log('身份证照片base64:', e.target.result);
			// 	// 你可以把这个base64展示在页面上，或者直接上传给后端
			// };
			// reader.readAsDataURL(file);
		},
		start() {
			Fetch('/user/info').then((r) => {
				this.data = r.data;
			});
		},
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		sendcode() {
			if (this.is_send) {
				return;
			}
			this.is_send = true;

			Fetch("/index/auth_email_code").then(() => {
				this.time = 60 * 1000;
				this.$toast({
					background: "#07c160",
					message: this.$t('authEmail.sendsuccess'),
				});
			})
				.catch(() => {
					this.is_send = false;
				});
		},
		submit() {
			
			const idcardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
			if (!idcardReg.test(this.datas.idcard)) {
				this.$toast('身份证号码格式不正确');
				return false;
			}
			if (!this.datas.name) {
				this.$toast('需要姓名');
				return false;
			}
			if (!this.datas.idcard) {
				this.$toast({
					className: "toastName",
					message: '需要身份证号码',
				});
				return false;
			}
			// if (!this.datas.img) {
			// 	this.$toast('需要身份证上传');
			// 	return false;
			// }
			Fetch('/user/real_add', {
				...this.datas
			}).then(r => {
				this.$router.go(-1);
			})
			// Fetch('/user/auth_email', {
			// 	code: this.code
			// }).then(() => {
			// 	this.$toast({
			// 		background: '#07c160',
			// 		message: this.$t('authEmail.success')
			// 	});
			// 	if (this.$route.query.redirect) {
			// 		this.$router.replace(this.$route.query.redirect + "&money=" + this.$route.query.money)
			// 	} else {
			// 		this.$router.replace('/safe')
			// 	}
			// });
		},
	}
};
</script>

<style lang="less" scoped>
.back_left {
	background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
	color: #000000;
}

.tittle_verified {
	margin-top: 40px;
	margin-bottom: 20px;
	font-size: 26px;
}

.form {
	width: 100%;
	margin-top: 32px;
	padding: 0 20px;

	.item {
		width: 100%;
		height: 45px;
		border-radius: 2px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 40px 0;

		input {
			flex: 1;
			padding: 0 10px;
			height: 22px;
			font-size: 16px;
			line-height: 22px;
		}

		.right_icon {
			width: 13px;
			height: 13px;
			background: url(../images/item/clear.png) no-repeat center center;
			background-size: 100% 100%;
			margin-right: 12px;
		}
	}

	.add-card {
		margin: 20px 0;
		display: block;
		width: 100%;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.preview-img {
		margin: 20px 0;
		display: block;
		width: 100%;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
	}
}

.basic_btn {
	width: 100%;
	margin-top: 10px;
}
</style>
